/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:contents}"];
export { styles as styles };
//# sourceMappingURL=notifications-list-iframe.component.scss.shim.ngstyle.js.map


//////////////////
// WEBPACK FOOTER
// ./ts/app/notifications-list/notifications-list-iframe/notifications-list-iframe.component.scss.shim.ngstyle.js
// module id = 1753
// module chunks = 27 28 29